export const rulesAndAlertsFormModel = {
  formId: 'RulesAndAlertsForm',
  formField: {
    name: {
      name: 'name',
      label: 'Nombre de la regla',
      requiredErrorMsg: 'El nombre es obligatorio',
    },
    description: {
      name: 'description',
      label: 'Descripción',
    },
    status: {
      name: 'status',
      label: 'Estado',
    },
    assignedUsers: {
      name: 'assignedUsers',
      label: 'Usuarios asignados',
    },
  },
};
